import { useState, useEffect } from 'react';
import axios from 'axios';
import { Badge } from './ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { Sparkles } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Tiny status pill that reads /api/performance-loop/summary and renders
 * "Konnect is learning from you" when the tenant has at least one performance
 * data point. Designed for the operator/subscriber dashboard header.
 */
export const HoloLearningBadge = () => {
  const [active, setActive] = useState(false);
  const [posts, setPosts] = useState(0);

  useEffect(() => {
    axios.get(`${API_URL}/api/performance-loop/summary?days=60`)
      .then(r => {
        setActive(!!r.data?.data_available);
        setPosts(r.data?.kpis?.total_posts || 0);
      })
      .catch(() => {});
  }, []);

  if (!active) return null;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            className="bg-gradient-to-r from-purple-500/15 to-emerald-500/15 text-emerald-700 border border-emerald-200 gap-1.5 cursor-help"
            data-testid="holo-learning-badge"
          >
            <span className="relative flex h-1.5 w-1.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-500" />
            </span>
            <Sparkles className="h-3 w-3" />
            Konnect is learning from you
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="max-w-xs">
          <p className="text-xs">
            Konnect has analysed <strong>{posts}</strong> of your published posts.
            Each future generation is tuned with what your audience actually responds to.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default HoloLearningBadge;
